module.exports = __webpack_public_path__ + "static/media/left-medial-nonflexion-up.b667a235.png";